import { MACRO_KEY } from "../../../defaults";
import { createSummaryFromData } from "./macros/titletext-summary";

const cardsHandler = (macroData) => ({
  data: JSON.stringify(macroData),
  macro: MACRO_KEY.CARDS,
});

const buttonHandler = (macroData, macro) => ({
  ...macroData,
  icon: JSON.stringify(macroData.icon),
  url: JSON.stringify(macroData.url),
  accentColor: JSON.stringify(macroData.accentColor),
  backgroundColor: JSON.stringify(macroData.backgroundColor),
  border: JSON.stringify(macroData.border),
  labelColor: JSON.stringify(macroData.labelColor),
  macro: macro,
});

const spacerAndDividerHandler = (macroData) => ({
  ...macroData,
  emoji: JSON.stringify(macroData.emoji),
  color: JSON.stringify(macroData.color),
  textColor: JSON.stringify(macroData.textColor),
  iconColor: JSON.stringify(macroData.iconColor),
  macro: MACRO_KEY.SPACER_AND_DIVIDER,
});

const panelSimpleHandler = (macroData) => ({
  ...macroData,
  icon: macroData.icon ? JSON.stringify(macroData.icon) : undefined,
  alignment: macroData.alignment
    ? JSON.stringify(macroData.alignment)
    : undefined,
  accentColor: JSON.stringify(macroData.accentColor),
  textColor: JSON.stringify(macroData.textColor),
  displayElements: JSON.stringify(macroData.displayElements),
  macro: MACRO_KEY.PANEL_SIMPLE,
});

const panelAdvancedHandler = (macroData) => ({
  data: JSON.stringify(macroData),
  macro: MACRO_KEY.PANEL_ADVANCED,
});

const announcementsHandler = (macroData) => ({
  data: JSON.stringify(macroData),
  macro: MACRO_KEY.ANNOUNCEMENTS,
});

const countdownHandler = (macroData) => ({
  data: JSON.stringify(macroData),
  macro: MACRO_KEY.COUNTDOWN,
});

const imageSliderHandler = (macroData) => ({
  data: JSON.stringify(macroData),
  macro: MACRO_KEY.IMAGE_SLIDER,
});

const advancedTabsGroupHandler = (macroData) => ({
  data: JSON.stringify(macroData),
  macro: MACRO_KEY.ADVANCED_TABS_GROUP,
});

const advancedTabsSingleHandler = (macroData) => ({
  data: JSON.stringify(macroData),
  macro: MACRO_KEY.ADVANCED_TABS_SINGLE,
});

const titletextHandler = (macroData) => {
  const summary = createSummaryFromData(macroData, macroData.layout);
  return {
    summary,
    ...macroData,
    emoji: JSON.stringify(macroData?.emoji || {}),
    layout: JSON.stringify(macroData?.layout),
    colorsByColorScheme: JSON.stringify(macroData?.colorsByColorScheme || {}),
    macro: MACRO_KEY.TEXT_AND_TITLE,
  };
};

const tooltipFootnoteHandler = (macroData) => ({
  ...macroData,
  macro: MACRO_KEY.TOOLTIPS_AND_FOOTNOTES,
  color: JSON.stringify(macroData.color),
  textColor: JSON.stringify(
    macroData?.textColor || { light: "#fff", dark: "#fff" }
  ),
});

const htmlHandler = (macroData) => ({
  theme: JSON.stringify(macroData.theme),
  contentByMode: JSON.stringify(macroData.contentByMode),
  macro: MACRO_KEY.HTML,
});

const footnoteDisplayHandler = (macroData) => {
  return {
    ...macroData,
    macro: MACRO_KEY.FOOTNOTE_DISPLAY,
  };
};

const handlers = {
  [MACRO_KEY.BUTTON]: buttonHandler,
  [MACRO_KEY.BUTTON_INLINE]: buttonHandler,
  [MACRO_KEY.CARDS]: cardsHandler,
  [MACRO_KEY.PANEL_SIMPLE]: panelSimpleHandler,
  [MACRO_KEY.ANNOUNCEMENTS]: announcementsHandler,
  [MACRO_KEY.COUNTDOWN]: countdownHandler,
  [MACRO_KEY.SPACER_AND_DIVIDER]: spacerAndDividerHandler,
  [MACRO_KEY.TEXT_AND_TITLE]: titletextHandler,
  [MACRO_KEY.IMAGE_SLIDER]: imageSliderHandler,
  [MACRO_KEY.FOOTNOTE_DISPLAY]: footnoteDisplayHandler,
  [MACRO_KEY.TOOLTIPS_AND_FOOTNOTES]: tooltipFootnoteHandler,
  [MACRO_KEY.ADVANCED_TABS_GROUP]: advancedTabsGroupHandler,
  [MACRO_KEY.ADVANCED_TABS_SINGLE]: advancedTabsSingleHandler,
  [MACRO_KEY.PANEL_ADVANCED]: panelAdvancedHandler,
  [MACRO_KEY.HTML]: htmlHandler,
};

export const handleSaveMacro = (macro, data) => {
  const handler = handlers[macro];
  if (handler) {
    return handler(data, macro);
  }
  return undefined;
};

export const saveAndClose = ({ data }) => {
  window.AP.confluence.saveMacro(data);
  window.AP.dialog.close();
};
